<app-list2 listId="core-mapping-spreadsheet-execution-view"
           [args]="params"
           (onLocalAction)="onLocalAction($event)"
           (onSingleItemOperation)="onSingleItemOperation($event)"
           #list>
</app-list2>
